export default __webpack_public_path__ + "static/media/google-ico.9e638e63.svg";